.statusboardLogin {
  background-color: #272333;
  color: white;
  padding: 4rem 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  text-decoration: none;
  min-height: 100vh;
  margin: 0;
}

main.statusboardLogin {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}

.logo {
  margin-bottom: 1rem;
}

form.loginForm {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.65rem;
  width: 95%;
  align-items: center;
}

&:-webkit-autofill::first-line,
&:-webkit-autofill,
&:-webkit-autofill:hover,
&:-webkit-autofill:focus,
&:-webkit-autofill:active {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
  font-size: 1rem;
}

.loginForm input {
  border-radius: 0.7rem;
  border: 0;
  font-size: 1rem;
  padding: 1rem;
  /* min-width: 20rem; */
  background-color: white !important;
  color: #000;
}

label,
.checklistTitle {
  font-size: 1rem;
  font-weight: 300;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding-bottom: 0.5rem;
  letter-spacing: 0.35px;
  
}

.checklistTitle {
  text-align: center;
}
.loginField {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.passwordField,
.usernameField {
  width: 100%;
}

.buttonArea button {
  color: white;
  border: 1px solid #673ab7;
  background-color: #673ab7;
  font-size: 1.1rem;
  border-radius: 4rem;
  padding: 0.6rem 1.75rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  border: 0;
  font-weight: 300;
  cursor: pointer;
}
.buttonArea button:hover {
  border: 1px solid white;
}

.buttonArea {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.login {
  justify-content: end;
}

.errorMessage {
  color: white;
  font-size: 0.9rem;
  display: none;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
}

.errorRoundel {
  background-color: white;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2rem;
  padding: 0.3rem;
}

.buttonArea .link {
  background-color: transparent;
  padding: 0;
  margin: 0;
  color: white;
  font-size: 0.9rem;
  font-weight: 300;
  text-decoration: none;
}
.buttonArea .link:hover {
  border: none;
}
.link:hover {
  text-decoration: underline;
}

.links {
  padding: 0 1rem;
}

.lockOff {
  display: none;
}

.lockOn {
  display: block;
}

.password,
.confirmPassword,
.username {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  background-color: white;
  border-radius: 0.7rem;
  padding-right: 1rem;
}

.username {
  padding-right: 0rem;
}

/* button:disabled {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

button:focus,
button:focus-visible,
button:active,
.links a:focus,
.links a:focus-visible,
.links a:active {
  border: 1px solid #ffffff;
}

input {
  outline: none;
  border: none;
} */

.password:focus-within,
.confirm-password:focus-within,
.username:focus-within {
  border: 2px solid #0ad80a;
}
.loginField :focus-visible{
  outline: none;
}

.passwordChecklist {
  margin: 0 auto;
  padding: 0 1rem;
  border-radius: 5px;
  pointer-events: none;
  transform: translateY(20px);
  transition: 0.5s ease;
  position: relative;
  top: -2rem;
}

.passwordStrength {
  display: flex;
  flex-direction: row;
  gap: 0rem;
  list-style: none;
  border: 1px solid white;
  border-radius: 1rem;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

.passwordStrength li {
  padding: 0.5rem 1.5rem;
}

.checklist {
  list-style: none;
  padding: 0;
}

.listItem {
  padding-left: 30px;
  color: #fff;
  font-size: 16px;
  font-weight: 300;
  display: flex;
  align-items: center;
}

.listItem::before {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>close</title><path fill="red" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>');
  content: "";
  /* font-family: FontAwesome; */
  display: inline-block;
  margin: 10px 1rem 12px -20px;
  /* font-size: 16px; */
  border-radius: 2rem;
  background-color: white;
  padding: 1rem;
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: center;
}

.listItem.checked {
  /* opacity: 0.5; */
  color: white;
}

.listItem.checked::before {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>check</title><path fill="green" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>');
  content: "";
  background-color: white;
  border-radius: 2rem; 
  padding: 1rem;
  background-size: 80%;
  background-repeat: no-repeat;
  background-position: center;
}

.buttonArea button:disabled {
  background-color: dimgrey;
  color: rgb(179, 179, 179);
  opacity: 1;
  border: 0;
}

.stepOne {
  background: linear-gradient(
    90deg,
    #ff0000 0%,
    #ff8000 100%
  );
}

.stepOneOthers {
  background-color: #ff8000;
}

.stepTwo {
  background: linear-gradient(
    90deg,
    #ff8000 0%,
    #c7a203 100%
  );
}

.stepTwoOthers {
  background-color: #c7a203;
}

.stepThree {
  background: linear-gradient(
    90deg,
    #c7a203 0%,
    #03adc7 100%
  );
}

.stepThreeOthers {
  background-color: #03adc7;
}

.stepFour {
  background: linear-gradient(90deg, #03adc7 0%, #0274b1);
}

.stepFourOthers {
  background-color: #0274b1;
}

.stepFive {
  background: linear-gradient(90deg, #0274b1, #03c303);
}

@media (min-width: 30em) {
  form.loginForm {
    width: 65%;
  }
}
@media (width >= 80em) {
  form.loginForm {
    width: 50%;
  }
}

@media (min-width: 48em) {
  form.loginForm {
    width: 60%;
  }
}

@media (min-width: 60em) {
  form.loginForm {
    width: 50%;
  }
}
